/**
 * Supported notification types.
 * @type {object}
 */
export const NOTIFICATION_TYPE = {
	NON_EMPLOYEE: 'NON_EMPLOYEE',
	WORK_QUEUE: 'WORK_QUEUE',
	STAFF_PRIVILEGE: 'STAFF_PRIVILEGE',
	APP_RECONCILIATION: 'APP_RECONCILIATION',
	SAA: 'SAA',
	APP_APPROVALS: 'APP_APPROVALS',
};
